import type { ReactNode } from 'react';

import classes from './ToolDisplay.module.css';

export interface ToolContentAreaProps {
  children: ReactNode;
}

/**
 * Bare content region of the tool-display grid — placement only, no
 * bubble chrome. Status renderers whose UI is its own surface (cards,
 * steppers) compose this directly; prose-like content composes
 * `ToolContentBubble` instead.
 */
export function ToolContentArea({ children }: ToolContentAreaProps) {
  return <div className={classes.toolContent}>{children}</div>;
}
